import { render, staticRenderFns } from "./page-section-group-layout.vue?vue&type=template&id=e9f56720&scoped=true"
import script from "./page-section-group-layout.vue?vue&type=script&lang=ts"
export * from "./page-section-group-layout.vue?vue&type=script&lang=ts"
import style0 from "./page-section-group-layout.vue?vue&type=style&index=0&id=e9f56720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f56720",
  null
  
)

export default component.exports